<template>
  <div class="Card-wrapper" :class="classes">
    <div class="Card py-5 px-3 px-sm-5 text-center text-lg-left">
      <slot name="Card-title" class="Card-title"></slot>
      <slot name="Card-body"></slot>
      <slot name="Card-button"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: Array,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Card {
  background-color: $colorWhite;
  box-shadow: 0 3px 30px rgba(0, 0, 0, .1);
  color: $colorPlum;
}

.Card-title {
  font-size: 36px;
  margin-bottom: 1em;
  position: relative;
  &::after {
    background-color: $colorEmerald;
    content: '';
    position: absolute;
    bottom: -.5em;
    left: 0;
    width: 33%;
    height: 8px;
    @media screen and (max-width: $grid-lg) {
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
    }
  }
  @media screen and (max-width: $grid-sm) {
      font-size: 2em;
    }
}

.Card-wrapper {
  z-index: $z-card;
}

.Card-wrapper--jumbo {
  margin-top: -9em;
  @media screen and (max-width: $grid-lg) {
    margin-top: -7em;
  }
  @media screen and (max-width: $grid-md) {
    margin-top: -3em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue